module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ModalBase', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    attrs: {
      "with-content": true
    },
    on: {
      "close": _vm.close
    }
  }, [_c('section', {
    staticClass: "fd-r fw-w m-jc-sb"
  }, [_c('div', {
    staticClass: "flexContainer fd-c ai-c jc-fs"
  }, [_c('div', {
    staticClass: "flexContainer fd-c"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t("plano.enter_new_name")))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedPlano.name),
      expression: "selectedPlano.name"
    }],
    staticClass: "full planoName mt10",
    attrs: {
      "placeholder": _vm.$t('plano.name_placeholder')
    },
    domProps: {
      "value": (_vm.selectedPlano.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.selectedPlano.name = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.nullName) ? _c('p', {
    staticClass: "danger"
  }, [_vm._v(_vm._s(_vm.$t("duplicatePlano.enterName")))]) : _vm._e()]), _vm._v(" "), _c('footer', [_c('ClientColorButton', {
    attrs: {
      "disabled": !_vm.planoNameIsCorrect
    },
    on: {
      "click": function($event) {
        _vm.savePlanoNewName();
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$t("plano.btn_validate")) + "\n                ")])], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cd9e6f06","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/planos/editName.vue
// module id = 3370
// module chunks = 0